module.exports = __webpack_public_path__ + "files/224a586787ebfcb5451c9da6d46daf64.png";